export default __webpack_public_path__ + "static/vscode-icons-b231793856e17f809943b90e4f6828be.png";